module.exports = __webpack_public_path__ + "static/hero-d6333427592aea11e6b4e3c399dd332d.gif";